<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/participant-category"
                saveRoot="/participant-category"
                @onTrashClick="onTrashClick"
                :formStructure="dataFormStructures.category">
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/participant-category"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de la catégorie')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cette catégorie?')"></ModalTrash>
    </div>
</template>

<script>
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    export default {
        name: 'ParticipantCategory',
        components: {
            DynamicForm,
            ModalTrash
        },
        mounted() {
        },
        data: function () {
            return {
                dataCapsGroups: [],
                Core: window.Core,
                dataId: '',
                dataFormStructures: {
                    category: {
                        rows: [
                            {
                                cols: [
                                    {
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Catégorie'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'title'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'color'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'title',
                                type: 'text',
                                label: Core.Definition.getDefinition('Titre'),
                                value: ''
                            },
                            {
                                id: 'color',
                                type: 'color',
                                mode: 'sketch',
                                label: Core.Definition.getDefinition('Couleur'),
                                value: {}
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/participant/categories')
            }
        }
    }
</script>
